import ClienteBuscaAvancadaModal from './ClienteBuscaAvancadaModal';

export default ClienteBuscaAvancadaModal;
